module.exports = __webpack_public_path__ + "static/media/t_nor_04.4ce456bd.png";